export const BUILD_VERSION: string | null = '1793840001999';
